import styled from 'styled-components';
const SearchCatalogueContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px 25px;
  margin-top: 20px;
  position: relative;
  min-width: 550px;
  min-height: 400px;
`;
const SearchCatalogueTitle = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 30px;
  font-weight: 700;
`;
const SearchCatalogueContent = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
`;
const SearchCatalogueLeftContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 9px;
`;
const SearchCatalogueRightContent = styled.div`
  flex: 1;
  margin-left: 94px;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const CatalogueContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: start;
  margin-top: 20px;
`;
const CatalogueGridTileContainer = styled.a`
  margin: 10px 24px 10px 0px;
  text-decoration: none;
  cursor: pointer;
  width: 97px;
`;
const CatalogueGridTile = styled.div`
  height: 97px;
  width: 97px;
`;
const CatalogueGridTileTitle = styled.div`
  font-size: 15px;
  font-weight: 400;
  margin-top: 8px;
  color: black;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const InitialTitle = styled.div`
  margin-top: 40px;
  font-size: 20px;
  font-weight: 400;
`;
const CatalogueImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
`;
const LoaderContainer = styled.div`
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Error = styled.div`
  margin-top: 40px;
  font-size: 20px;
  font-weight: 400;
`;
const DownloadAndLoaderContainer = styled.div`
  display: flex;
  align-items: center;
`;
const GetCataloguesLoader = styled.div`
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const DownloadLoader = styled.div`
  margin-left: 10px;
`;
export default {
  SearchCatalogueContainer,
  SearchCatalogueTitle,
  SearchCatalogueContent,
  SearchCatalogueLeftContent,
  SearchCatalogueRightContent,
  CatalogueContainer,
  CatalogueGridTileContainer,
  CatalogueGridTile,
  CatalogueGridTileTitle,
  InitialTitle,
  CatalogueImage,
  LoaderContainer,
  Error,
  DownloadAndLoaderContainer,
  GetCataloguesLoader,
  DownloadLoader
};



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/CatalogueSearch/styles.js